import { render } from "./RiwayatPendaftaranView.vue?vue&type=template&id=7318e87a&scoped=true"
import script from "./RiwayatPendaftaranView.vue?vue&type=script&lang=js"
export * from "./RiwayatPendaftaranView.vue?vue&type=script&lang=js"

import "./RiwayatPendaftaranView.vue?vue&type=style&index=0&id=7318e87a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7318e87a"]])

export default __exports__